module.exports = __webpack_public_path__ + "img/l_d8.9afc6273.png";